import React from 'react';
import styled from 'styled-components';
import InfoBlue from '@Utils/shared/components/Icons-v3/InfoBlue';
import { useTooltipContext } from '@Utils/shared/components/RaidIdTooltip/tooltipContext';

const ButtonElement = styled.button`
  position: absolute;
  top: -35px;
  right: 0px;
  z-index: 2;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: none;
  border: none;
  cursor: pointer;
`;

const TooltipSwitchButton: ReactFCWithChildren<{ style?: object }> = ({ style = {} }) => {
  const ref = React.useRef<HTMLButtonElement | null>(null);
  const { setIsShow, isShow } = useTooltipContext();

  const showTooltip = () => {
    setIsShow((prev) => (prev ? false : true));
  };

  return (
    <ButtonElement
      ref={ref}
      type="button"
      onClick={showTooltip}
      style={{ ...style, pointerEvents: isShow ? 'none' : 'all' }}
    >
      <InfoBlue width={20} height={20} />
    </ButtonElement>
  );
};

export default TooltipSwitchButton;
